<template>
  <v-container>
    <div class="text-center" v-if="!storeSchema">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
    <dynamic-form
      v-else
      ref="form"
      :options="{
        company: {exclude: true},
        slug: {exclude: true},
        branding: {exclude: true}
      }"
      :schema="storeSchema"
      :value="item"
      @submit="submitForm($event)"
    />
  </v-container>
</template>

<script>
import DynamicForm from '@/components/DynamicForm.vue'
import { mapActions, mapGetters } from 'vuex'
import redaApp from '../api/redaApp'

export default {
  name: 'StoreForm',
  props: {
    item: Object
  },
  components: {
    DynamicForm
  },
  data () {
    return {
      uid: this.item?.uid || null,
      loading: false,
      storeSchema: null
    }
  },

  computed: {
    ...mapGetters('user', [
      'getUser'
    ]),
    ...mapGetters('company', [
      'getCompany'
    ])
  },
  methods: {
    async insertStore (payload) {
      if (payload.company) payload.company = this.getCompany.identification
      if (this.uid) {
        return redaApp.update('stores', payload, this.uid, true)
      }
      return redaApp.create('stores', payload, true)
    },
    submitForm (store) {
      this.loading = true
      this.insertStore({ ...store })
        .then(() => this.showSuccess('Tienda guardada'))
        .catch((e) => {
          console.error(e)
          this.showError('Error al guardar tienda')
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveForm () {
      if (this.$refs.form.validate()) {
        this.loading = true
        console.log('Form is valid and ready to save')
        console.log(this.store)
        this.insertStore({ ...this.store })
          .then(() => this.showSuccess('Store guardado'))
          .catch((e) => {
            console.error(e)
            this.showError('Error al guardar trámite')
          })
          .finally(() => {
            this.loading = false
          })
        // You can send `this.store` as JSON via an API request
      }
    },
    ...mapActions('message', [
      'showSuccess',
      'showInfo',
      'showWarning',
      'showError'
    ])
  },
  watch: {
  },
  mounted: function () {
    redaApp.getDescribe('stores').then((schema) => {
      this.storeSchema = schema
    }).catch((e) => {
      console.error(e)
    })
  }
}
</script>
